(function() {

  // ── LANGUAGE ───────────────────────────────────────────────────────────────
  var _lang = 'en';
  try {
    if (localStorage.getItem('preferred_language') === 'es') _lang = 'es';
  } catch(e) {}

  var T = {
    en: {
      pageTitle:        'Manage Membership',
      pageSubtitle:     'Manage your subscription and keep your account details up to date.',
      billingTitle:     'Subscription & Billing',
      accountTitle:     'Account & Security',
      accountDesc:      'To change your password, update your login email, or manage devices, use our secure portal:',
      accountLink:      'Go to Account Settings →',
      groupTitle:       'Group & Team Settings',
      groupDesc:        'Manage your group members, invites, and group details:',
      groupLink:        'Go to Group Settings →',
      footerDelete:     'Need to leave us? <a href="/pages/delete-account">Request Account Deletion</a>',
      footerContact:    'Questions? Contact us at <a href="mailto:contact@grouphiit.com">contact@grouphiit.com</a>',
      loggedOutTitle:   'Manage Membership',
      loggedOutDesc:    'Please sign in to view and manage your membership details.',
      signIn:           'Sign In',
      manageBtn:        'Manage Subscription',
      reactivateBtn:    'Reactivate or Manage',
      viewPlansBtn:     'View Plans & Join',
      manageApple:      'Manage on Apple',
      manageRoku:       'Manage on Roku',
  
      trialCancelledWithExpiry: 'Your <strong>free trial has been cancelled</strong> and will end on <strong>{date}</strong>. You will not be charged.',
      trialCancelledNoExpiry:   'Your <strong>free trial has been cancelled</strong>. You will not be charged.',
      grantedAccess:    'Your access has been <strong>granted</strong> by the Group HIIT team. {expiryText} Please contact <a href="mailto:contact@grouphiit.com" style="color:#00bcd4;">contact@grouphiit.com</a> for questions.',
      grantedExpiry:    'Your access is valid until <strong>{date}</strong>.',
      grantedNoExpiry:  'Your access does not have an expiration date.',
      trialWithExpiry:  'You are currently in your <strong>free trial</strong>, which ends on <strong>{date}</strong>. After your trial you will be charged automatically.',
      trialNoExpiry:    'You are currently in your <strong>free trial</strong>.',
      activeRenews:     'Your membership is active and renews on <strong>{date}</strong>.',
      activeCancelled:  'Your membership has been cancelled and will remain active until <strong>{date}</strong>. You will not be billed again after this date. If this was a mistake you can reactivate below.',
      activeNoExpiry:   'Your membership is active.',
      managePortalNote: 'To cancel or make changes to your subscription, click the management link in your last payment confirmation email.',
      appleManaged:     'Your membership is managed by <strong>Apple</strong> and {renewalText}. To make changes, manage your subscription directly with Apple.',
      rokuManaged:      'Your membership is managed by <strong>Roku</strong> and {renewalText}. To make changes, manage your subscription directly with Roku.',
      renewsOn:         'renews on <strong>{date}</strong>',
      activeUntil:      'active until <strong>{date}</strong>',
      activeNoDate:     'active',
      unknownBilling:   'Your membership is active. Please contact <a href="mailto:contact@grouphiit.com" style="color:#00bcd4;">contact@grouphiit.com</a> for billing management.',
      noSubOrg:         'Your group membership has expired or is no longer active. Please contact your group administrator to restore access, or start your own membership below.',
      noSubIndividual:  'You do not have an active membership. Start your free trial below.',
      groupMemberSub:   'Your membership is provided by <strong>{orgName}</strong>. Please contact the primary billing manager for subscription changes.',
      noSubIndividualWinBack: 'Your membership has expired. Resubscribe to get full access.',
      viewPlansBtn: 'View Plans',
      cancelledUntil: 'Your membership has been cancelled and will remain active until {{date}}. You will not be billed again.',
      managedThroughWeb: 'Your subscription is managed through the web.',
      managedThroughWebiOS: 'Your subscription is managed through the web. Visit grouphiit.com to make changes.',
      storeNote:        '<strong>Note for App Users:</strong> If you subscribed via the <strong>Roku Channel</strong> or <strong>Apple App Store</strong>, use the instructions above to manage those subscriptions on their respective platforms.',
      // Seat usage
      seatUsage:        '<strong>{used}</strong> of <strong>{total}</strong> seats used',
      seatNearFull:     'Your group is nearly full. <a href="{portalUrl}">Upgrade your plan</a> in the billing portal to add more seats.',
      seatFull:         'Your group is at capacity. <a href="{portalUrl}">Upgrade your plan</a> in the billing portal to add more seats.',
      seatDowngrade:    'You can also upgrade, downgrade or cancel your plan anytime in the <a href="{portalUrl}">billing portal</a>.',
    },
    es: {
      pageTitle:        'Gestionar Membresía',
      pageSubtitle:     'Administra tu suscripción y mantén tus datos actualizados.',
      billingTitle:     'Suscripción y Facturación',
      accountTitle:     'Cuenta y Seguridad',
      accountDesc:      'Para cambiar tu contraseña, actualizar tu correo o gestionar dispositivos, usa nuestro portal seguro:',
      accountLink:      'Ir a Configuración de Cuenta →',
      groupTitle:       'Configuración del Grupo',
      groupDesc:        'Administra tus miembros, invitaciones y detalles del grupo:',
      groupLink:        'Ir a Configuración del Grupo →',
      footerDelete:     '¿Necesitas irte? <a href="/pages/delete-account">Solicitar Eliminación de Cuenta</a>',
      footerContact:    '¿Preguntas? Contáctanos en <a href="mailto:contact@grouphiit.com">contact@grouphiit.com</a>',
      loggedOutTitle:   'Gestionar Membresía',
      loggedOutDesc:    'Por favor inicia sesión para ver y gestionar los detalles de tu membresía.',
      signIn:           'Iniciar Sesión',
      manageBtn:        'Gestionar Suscripción',
      reactivateBtn:    'Reactivar o Gestionar',
      viewPlansBtn:     'Ver Planes y Unirse',
      manageApple:      'Gestionar en Apple',
      manageRoku:       'Gestionar en Roku',
      trialCancelledWithExpiry: 'Tu <strong>período de prueba ha sido cancelado</strong> y terminará el <strong>{date}</strong>. No se realizará ningún cobro.',
      trialCancelledNoExpiry:   'Tu <strong>período de prueba ha sido cancelado</strong>. No se realizará ningún cobro.',
      grantedAccess:    'Tu acceso ha sido <strong>otorgado</strong> por el equipo de Group HIIT. {expiryText} Contacta a <a href="mailto:contact@grouphiit.com" style="color:#00bcd4;">contact@grouphiit.com</a> para más información.',
      grantedExpiry:    'Tu acceso es válido hasta el <strong>{date}</strong>.',
      grantedNoExpiry:  'Tu acceso no tiene fecha de vencimiento.',
      trialWithExpiry:  'Estás en tu <strong>período de prueba gratuito</strong>, que termina el <strong>{date}</strong>. Después de la prueba se realizará el cobro automáticamente.',
      trialNoExpiry:    'Estás en tu <strong>período de prueba gratuito</strong>.',
      activeRenews:     'Tu membresía está activa y se renueva el <strong>{date}</strong>.',
      activeCancelled:  'Tu membresía está activa hasta el <strong>{date}</strong>. No se realizarán más cobros después de esa fecha. Si fue un error, puedes reactivarla abajo.',
      activeNoExpiry:   'Tu membresía está activa.',
      managePortalNote: 'Para cancelar o hacer cambios en tu suscripción, haz clic en el enlace de gestión en tu último correo de confirmación de pago.',
      appleManaged:     'Tu membresía es gestionada por <strong>Apple</strong> y {renewalText}. Para hacer cambios, gestiona tu suscripción directamente con Apple.',
      rokuManaged:      'Tu membresía es gestionada por <strong>Roku</strong> y {renewalText}. Para hacer cambios, gestiona tu suscripción directamente con Roku.',
      renewsOn:         'se renueva el <strong>{date}</strong>',
      activeUntil:      'activa hasta el <strong>{date}</strong>',
      activeNoDate:     'activa',
      unknownBilling:   'Tu membresía está activa. Contacta a <a href="mailto:contact@grouphiit.com" style="color:#00bcd4;">contact@grouphiit.com</a> para gestión de facturación.',
      noSubOrg:         'Tu membresía grupal ha expirado o ya no está activa. Contacta a tu administrador para restablecer el acceso, o inicia tu propia membresía abajo.',
      noSubIndividual:  'No tienes una membresía activa. Comienza tu período de prueba gratuito abajo.',
      noSubIndividualWinBack: 'Tu membresía ha expirado. Vuelve a suscribirte para obtener acceso completo.',
      viewPlansBtn: 'Ver Planes',
      cancelledUntil: 'Tu membresía ha sido cancelada y permanecerá activa hasta el {{date}}. No se te cobrará nuevamente.',
managedThroughWeb: 'Tu suscripción se gestiona a través de la web.',
managedThroughWebiOS: 'Tu suscripción se gestiona a través de la web. Visita grouphiit.com para hacer cambios.',
      groupMemberSub:   'Tu membresía es proporcionada por <strong>{orgName}</strong>. Contacta al responsable de facturación principal para cambios en la suscripción.',
      storeNote:        '<strong>Nota para usuarios de apps:</strong> Si te suscribiste a través del <strong>Canal de Roku</strong> o la <strong>App Store de Apple</strong>, usa las instrucciones anteriores para gestionar esas suscripciones en sus respectivas plataformas.',
      seatUsage:        '<strong>{used}</strong> de <strong>{total}</strong> lugares usados',
      seatNearFull:     'Tu grupo está casi lleno. <a href="{portalUrl}">Actualiza tu plan</a> en el portal de facturación para agregar más lugares.',
      seatFull:         'Tu grupo está al máximo de capacidad. <a href="{portalUrl}">Actualiza tu plan</a> en el portal de facturación para agregar más lugares.',
      seatDowngrade:    'También puedes cambiar a un plan menor o cancelar en cualquier momento desde el <a href="{portalUrl}">portal de facturación</a>.',
    }
  };

  function t(key, vars) {
    var str = (T[_lang] && T[_lang][key]) || T['en'][key] || key;
    if (vars) {
      Object.keys(vars).forEach(function(k) {
        str = str.replace(new RegExp('{' + k + '}', 'g'), vars[k]);
      });
    }
    return str;
  }

  function applyLanguage() {
    // Check user metadata for language preference
    try {
      if (window.Clerk && window.Clerk.user &&
          window.Clerk.user.unsafeMetadata &&
          window.Clerk.user.unsafeMetadata.preferred_language === 'es') {
        _lang = 'es';
      }
    } catch(e) {}

    // Stripe portal locale
    _stripeLocale = _lang === 'es' ? 'es' : 'en';

    // Apply all static text
    setText('mm-title',        t('pageTitle'));
    setText('mm-subtitle',     t('pageSubtitle'));
    setText('mm-billing-title',t('billingTitle'));
    setText('mm-account-title',t('accountTitle'));
    setText('mm-account-desc', t('accountDesc'));
    setText('mm-account-link', t('accountLink'));
    setText('mm-group-title',  t('groupTitle'));
    setText('mm-group-desc',   t('groupDesc'));
    setText('mm-group-link',   t('groupLink'));
    setHTML('mm-footer-delete',t('footerDelete'));
    setHTML('mm-footer-contact',t('footerContact'));
    setText('mm-lo-title',     t('loggedOutTitle'));
    setText('mm-lo-desc',      t('loggedOutDesc'));
    setText('mm-lo-btn',       t('signIn'));
  }

  function setText(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  function setHTML(id, val) {
    var el = document.getElementById(id);
    if (el) el.innerHTML = val;
  }

  // ── STRIPE CONFIG ──────────────────────────────────────────────────────────
  var STRIPE_INDIVIDUAL_PORTAL = 'https://billing.stripe.com/p/login/14AbJ0ekn08a2nn1dcfw400';
  var STRIPE_GROUP_PORTAL      = 'https://billing.stripe.com/p/login/5kQ7sK4JN5su5zzaNMfw401';
  var _stripeLocale = 'en';

  function getStripeUrl(isGroup, email) {
    var base = isGroup ? STRIPE_GROUP_PORTAL : STRIPE_INDIVIDUAL_PORTAL;
    var url  = base + '?prefilled_email=' + encodeURIComponent(email || '');
    if (_stripeLocale === 'es') url += '&locale=es';
    return url;
  }

  // ── PLAN DETAILS ───────────────────────────────────────────────────────────
 var PLAN_DETAILS = {
  // Current Stripe Billing (new customers)
  'prod_TWce9ooDqdPUjo': { name: 'Annual Membership',  seats: 1,   billing: 'Annual'  },
  'prod_TWNglbccvEwHfi': { name: 'Monthly Membership', seats: 1,   billing: 'Monthly' },
  'prod_U8aWvk1kRCUA3U': { name: 'Family Plan',        seats: 10,  billing: 'Monthly' },
  'prod_U8aIR1vPFELO07': { name: 'Family Plan',        seats: 10,  billing: 'Annual'  },
  'prod_U8ahdP8lB0UWI5': { name: 'Growth Plan',        seats: 50,  billing: 'Monthly' },
  'prod_U8adaw3nYpTRj6': { name: 'Growth Plan',        seats: 50,  billing: 'Annual'  },
  'prod_U8atlKQDNZ6b7A': { name: 'Business Plan',      seats: 150, billing: 'Monthly' },
  'prod_U8apDmKqWpmNTo': { name: 'Business Plan',      seats: 150, billing: 'Annual'  },
  // iOS App Store and Roku New
  'member_annual':        { name: 'Annual Membership',  billing: 'Annual',  seats: 1 },
  'member_6month':        { name: '6 Month Membership', billing: '6 Month', seats: 1 },
  'member_monthly':       { name: 'Monthly Membership', billing: 'Monthly', seats: 1 },
  // Roku Legacy
  'grouphiitannual':      { name: 'Annual Membership',  billing: 'Annual',  seats: 1 },
  'grouphiitmonthly':     { name: 'Monthly Membership', billing: 'Monthly', seats: 1 },
  // Legacy InPlayer migrated — Stripe Billing
  'prod_I6gqC5gKS3WhrE': { name: 'Monthly Membership', seats: 1, billing: 'Monthly' },
  'prod_IKuUaAGd5eGEVi': { name: 'Monthly Membership', seats: 1, billing: 'Monthly' },
  'prod_JJTdWC0V6KsrSi': { name: 'Monthly Membership', seats: 1, billing: 'Monthly' },
  'prod_MrpNfO1XT7Z6Mx': { name: 'Monthly Membership', seats: 1, billing: 'Monthly' },
  'prod_NGy7YW71skP0dy': { name: 'Monthly Membership', seats: 1, billing: 'Monthly' },
  'prod_O6QOi98dFqbMng': { name: 'Monthly Membership', seats: 1, billing: 'Monthly' },
  'prod_RlhYCzB01zf1br': { name: 'Monthly Membership', seats: 1, billing: 'Monthly' },
  'prod_I6h3WTXwWrYEBq': { name: 'Annual Membership',  seats: 1, billing: 'Annual'  },
  'prod_IQ7InPGa1SHUho': { name: 'Annual Membership',  seats: 1, billing: 'Annual'  },
  'prod_Ku0DDaJ7UXj7EK': { name: 'Annual Membership',  seats: 1, billing: 'Annual'  },
  'prod_N4X2be2r0h7NBW': { name: 'Annual Membership',  seats: 1, billing: 'Annual'  },
  'prod_QjwzyJJjAy19eE': { name: 'Annual Membership',  seats: 1, billing: 'Annual'  },
  'prod_Pex3oebpIP3L18': { name: 'Annual Membership',  seats: 1, billing: 'Annual'  },
  'prod_IKxT4duEmJshri': { name: '6 Month Membership', seats: 1, billing: '6 Month' },
  'prod_OhX6EedFQaCgHu': { name: '6 Month Membership', seats: 1, billing: '6 Month' },
  'prod_Q3MKvmljsWLJBm': { name: '6 Month Membership', seats: 1, billing: '6 Month' },
};


  var PLAN_NAMES_ES = {
    'Annual Membership':  'Membresía Anual',
    'Monthly Membership': 'Membresía Mensual',
    'Family Plan':        'Plan Familiar',
    'Growth Plan':        'Plan de Crecimiento',
    'Business Plan':      'Plan Empresarial',
  };

  function getPlanName(name) {
    return (_lang === 'es' && PLAN_NAMES_ES[name]) ? PLAN_NAMES_ES[name] : name;
  }

  function formatDate(dateStr) {
    if (!dateStr) return null;
    var locale = _lang === 'es' ? 'es-ES' : 'en-US';
    return new Date(dateStr).toLocaleDateString(locale, {
      year: 'numeric', month: 'long', day: 'numeric'
    });
  }

  // ── SEAT COUNT ─────────────────────────────────────────────────────────────
  async function loadSeatCount(totalSeats, portalUrl) {
    var container = document.getElementById('mm-seat-bar');
    if (!container) return;

    try {
      var memberships = await window.Clerk.organization.getMemberships({ limit: 100 });
      var used = memberships.data.length;
      var pct  = Math.min(100, Math.round((used / totalSeats) * 100));
      var fillClass = pct >= 100 ? 'full' : pct >= 80 ? 'warning' : '';

      var upgradeNote = '';
      if (pct >= 100) {
        upgradeNote = '<p class="mm-seat-upgrade-note">' + t('seatFull', { portalUrl: portalUrl }) + '</p>';
      } else if (pct >= 80) {
        upgradeNote = '<p class="mm-seat-upgrade-note">' + t('seatNearFull', { portalUrl: portalUrl }) + '</p>';
      }

      var downgradeNote = '<p class="mm-seat-upgrade-note">' + t('seatDowngrade', { portalUrl: portalUrl }) + '</p>';

      container.innerHTML =
        '<div class="mm-seat-bar-wrap">' +
          '<div class="mm-seat-bar-label">' +
            '<span>' + t('seatUsage', { used: used, total: totalSeats }) + '</span>' +
            '<span>' + pct + '%</span>' +
          '</div>' +
          '<div class="mm-seat-bar-track">' +
            '<div class="mm-seat-bar-fill ' + fillClass + '" style="width:' + pct + '%"></div>' +
          '</div>' +
        '</div>' +
        upgradeNote +
        downgradeNote;
    } catch(e) {
      console.warn('[MM] Could not load seat count:', e);
      container.innerHTML = '';
    }
  }

  // ── UPDATE BILLING UI ──────────────────────────────────────────────────────
  function updateBillingUI(customerInfo, offerings) {
    var statusText   = document.getElementById('subscription-status-text');
    var actionBtn    = document.getElementById('rc-customer-center-button');
    var instructions = document.getElementById('store-instructions');

    actionBtn.style.display    = 'none';
    instructions.style.display = 'none';
    instructions.innerHTML     = '';

    var activeEntitlements = customerInfo && customerInfo.entitlements && customerInfo.entitlements.active
      ? Object.values(customerInfo.entitlements.active)
      : [];

    if (activeEntitlements.length > 0) {
      // If user is a group member or admin, find their individual entitlement separately
      // so we can show both subscriptions if they have one
      var isGroupMemberOrAdmin = window.GH && 
        (window.GH.userType === 'group_member' || window.GH.userType === 'group_admin');

      var individualEntitlement = activeEntitlements.find(function(e) {
        var details = PLAN_DETAILS[e.productIdentifier];
        return details && details.seats === 1;
      });

      var groupEntitlement = activeEntitlements.find(function(e) {
        var details = PLAN_DETAILS[e.productIdentifier];
        return details && details.seats > 1;
      });

      var mainEntitlement = isGroupMemberOrAdmin 
        ? (groupEntitlement || activeEntitlements[0])
        : activeEntitlements[0];
      var store      = mainEntitlement.store;
      var willRenew  = mainEntitlement.willRenew;
      var expiry     = formatDate(mainEntitlement.expirationDate);
      var periodType = mainEntitlement.periodType;
      var planDetails = PLAN_DETAILS[mainEntitlement.productIdentifier] || null;

      var planDescriptions = {
        'prod_TWce9ooDqdPUjo': 'Unlimited access to all classes on Group HIIT',
        'prod_TWNglbccvEwHfi': 'Unlimited access to all classes on Group HIIT',
      };

      var productDescription = null;
      if (offerings) {
        var allPackages = Object.values(offerings.all || {}).flatMap(function(o) { return o.availablePackages || []; });
        var matchedPackage = allPackages.find(function(pkg) {
          return pkg.webBillingProduct && (
            pkg.webBillingProduct.identifier === mainEntitlement.productIdentifier ||
            pkg.webBillingProduct.productIdentifier === mainEntitlement.productIdentifier
          );
        });
        if (matchedPackage) {
          productDescription = matchedPackage.webBillingProduct.description ||
                               matchedPackage.webBillingProduct.localizedDescription || null;
        }
      } else {
        productDescription = planDescriptions[mainEntitlement.productIdentifier] || null;
      }

      var planLine = '';
      if (planDetails) {
        var seatsLabel = planDetails.seats > 1
          ? '<span style="background:#fffde7;color:#232a2e;padding:4px 12px;border-radius:999px;font-size:13px;font-weight:600;border:1px solid #ffee58;">' + planDetails.seats + ' seats</span>'
          : '';
        planLine =
          '<div style="margin-top:14px;">' +
            '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:8px;">' +
              '<span style="background:#e0f9fb;color:#232a2e;padding:4px 12px;border-radius:999px;font-size:13px;font-weight:600;border:1px solid #00bcd4;">' + getPlanName(planDetails.name) + '</span>' +
              seatsLabel +
            '</div>' +
            (productDescription ? '<p style="color:#37474f;font-size:13px;margin:0;">' + productDescription + '</p>' : '') +
            '<div id="mm-seat-bar"></div>' +
          '</div>';
      }

      var userEmail = window.Clerk && window.Clerk.user && window.Clerk.user.primaryEmailAddress
        ? window.Clerk.user.primaryEmailAddress.emailAddress : '';
      var isGroupOwner = window.GH && window.GH.userType === 'group_owner';
      var portalUrl = getStripeUrl(isGroupOwner, userEmail);

      if (store === 'promotional') {
  var isEnterpriseOwner = window.GH && window.GH.userType === 'group_owner';
  if (isEnterpriseOwner) {
    statusText.innerHTML = 
      '<p>' + (expiry 
        ? 'Your Enterprise Plan is active and provides access for your group until ' + expiry + '.' 
        : 'Your Enterprise Plan is active and provides access for your group.') + '</p>' +
      '<p style="margin-top:8px;font-size:13px;color:#37474f;">For billing and renewal, please contact <a href="mailto:contact@grouphiit.com" style="color:#00bcd4;">contact@grouphiit.com</a>.</p>';
  } else {
    var expiryText = expiry ? t('grantedExpiry', { date: expiry }) : t('grantedNoExpiry');
    statusText.innerHTML = '<p>' + t('grantedAccess', { expiryText: expiryText }) + '</p>';
  }

      } else if (store === 'stripe') {
        var statusMessage = '';
        if (periodType === 'trial') {
          statusMessage = expiry ? t('trialWithExpiry', { date: expiry }) : t('trialNoExpiry');
        } else if (willRenew && expiry) {
          statusMessage = t('activeRenews', { date: expiry });
        } else if (!willRenew && expiry) {
          statusMessage = t('activeCancelled', { date: expiry });
        } else {
          statusMessage = t('activeNoExpiry');
        }
        statusText.innerHTML =
          '<p>' + statusMessage + '</p>' +
          planLine;
        actionBtn.textContent   = (!willRenew && periodType !== 'trial') ? t('reactivateBtn') : t('manageBtn');
        actionBtn.style.display = 'inline-block';
        actionBtn.onclick = function() { window.location.href = portalUrl; };
        // Load seat count for group plans
        if (planDetails && planDetails.seats > 1 && window.Clerk && window.Clerk.organization) {
          loadSeatCount(planDetails.seats, portalUrl);
        }
      } else if (store === 'rc_billing') {
        var statusMessage = '';
        if (periodType === 'trial') {
          statusMessage = expiry ? t('trialWithExpiry', { date: expiry }) : t('trialNoExpiry');
        } else if (willRenew && expiry) {
          statusMessage = t('activeRenews', { date: expiry });
        } else if (!willRenew && expiry) {
          statusMessage = t('activeCancelled', { date: expiry });
        } else {
          statusMessage = t('activeNoExpiry');
        }
        statusText.innerHTML =
          '<p>' + statusMessage + '</p>' +
          planLine +
          '<p style="margin-top:10px;">' + t('managePortalNote') + '</p>';
        actionBtn.style.display = 'none';
        // Load seat count for group plans (display only, no portal link needed)
        if (planDetails && planDetails.seats > 1 && window.Clerk && window.Clerk.organization) {
          loadSeatCount(planDetails.seats, portalUrl);
        }

      } else if (store === 'app_store' || store === 'mac_app_store') {
        var renewalText = willRenew && expiry ? t('renewsOn', { date: expiry }) : expiry ? t('activeUntil', { date: expiry }) : t('activeNoDate');
        statusText.innerHTML = '<p>' + t('appleManaged', { renewalText: renewalText }) + '</p>' + planLine;
        actionBtn.textContent   = t('manageApple');
        actionBtn.style.display = 'inline-block';
        actionBtn.onclick = function() { window.location.href = 'https://apps.apple.com/account/subscriptions'; };
        instructions.style.display = 'block';
        instructions.innerHTML = '<p>' + t('storeNote') + '</p>';

      } else if (store === 'roku') {
        var renewalText = willRenew && expiry ? t('renewsOn', { date: expiry }) : expiry ? t('activeUntil', { date: expiry }) : t('activeNoDate');
        statusText.innerHTML = '<p>' + t('rokuManaged', { renewalText: renewalText }) + '</p>' + planLine;
        actionBtn.textContent   = t('manageRoku');
        actionBtn.style.display = 'inline-block';
        actionBtn.onclick = function() { window.location.href = 'https://my.roku.com/account/subscriptions'; };
        instructions.style.display = 'block';
        instructions.innerHTML = '<p>' + t('storeNote') + '</p>';

      } else {
        statusText.innerHTML = '<p>' + t('unknownBilling') + '</p>' + planLine;
      }

    // If group member/admin also has an active individual sub, show it separately
      if (isGroupMemberOrAdmin && individualEntitlement) {
        var indDetails = PLAN_DETAILS[individualEntitlement.productIdentifier];
        var indExpiry = formatDate(individualEntitlement.expirationDate);
        var indWillRenew = individualEntitlement.willRenew;
        var userEmail = window.Clerk && window.Clerk.user && window.Clerk.user.primaryEmailAddress
          ? window.Clerk.user.primaryEmailAddress.emailAddress : '';
        var indPortalUrl = getStripeUrl(false, userEmail);

        var indSection = document.getElementById('individual-sub-section');
        if (!indSection) {
          indSection = document.createElement('div');
          indSection.id = 'individual-sub-section';
          indSection.style.cssText = 'margin-top:24px;padding-top:24px;border-top:1px solid #e2e8f0;';
          statusText.parentNode.appendChild(indSection);
        }

        indSection.innerHTML = 
          '<p style="font-size:13px;font-weight:600;color:#232a2e;margin-bottom:8px;">Individual Subscription</p>' +
          '<p style="font-size:13px;color:#37474f;margin-bottom:8px;">' +
            (indDetails ? getPlanName(indDetails.name) : 'Individual Membership') + ' — ' +
            (indWillRenew && indExpiry ? 'Renews ' + indExpiry : indExpiry ? 'Active until ' + indExpiry : 'Active') +
          '</p>' +
          '<p style="font-size:13px;color:#37474f;margin-bottom:12px;">You have an active individual subscription alongside your group membership. To avoid duplicate charges you may want to cancel it.</p>' +
          '<button onclick="window.location.href=\'' + indPortalUrl + '\'" style="background:#232a2e;color:#ffee58;border:none;border-radius:8px;padding:10px 20px;font-size:13px;font-weight:600;cursor:pointer;">Manage Individual Plan</button>';
      }

    } else {
      // ── PAYPAL LEGACY CHECK ──────────────────────────────────────────────
      var isPaypalSubscriber = window.Clerk && window.Clerk.user &&
        window.Clerk.user.publicMetadata &&
        window.Clerk.user.publicMetadata.paypal_subscriber === true;
      if (isPaypalSubscriber) {
        statusText.innerHTML =
          '<p>Your membership is active and managed through <strong>PayPal</strong>.</p>' +
          '<p style="margin-top:8px;">To cancel your subscription, log in to your PayPal account and manage your subscription there. If you need help or want to switch to a new plan, you can wait until your subscription expires and then sign up for a new plan using a credit. If you have any questions, email us at <a href="mailto:contact@grouphiit.com" style="color:#00bcd4;">contact@grouphiit.com</a>.</p>';
        return;
      }
      // ── END PAYPAL LEGACY CHECK ──────────────────────────────────────────
      var inactiveOrg = window.Clerk && window.Clerk.user &&
        window.Clerk.user.organizationMemberships &&
        window.Clerk.user.organizationMemberships.length > 0;
      var hasGHAccess  = window.GH && window.GH.hasAccess === true;
      var isExpiredOwner = window.GH && window.GH.userType === 'group_owner' && !hasGHAccess;

      if (isExpiredOwner) {
        // Expired group owner — they need to renew, not contact an admin
        statusText.innerHTML = '<p>' + (_lang === 'es'
          ? 'Tu suscripción grupal ha expirado. Tus miembros han perdido acceso. Renueva tu suscripción para restaurar el acceso del grupo.'
          : 'Your group subscription has expired. Your members have lost access. Renew your subscription to restore access for the whole group.') + '</p>';
        actionBtn.textContent   = _lang === 'es' ? 'Renovar Suscripción' : 'Renew Subscription';
        actionBtn.style.display = 'inline-block';
        actionBtn.onclick = function() {
          window.location.href = '/pages/join-group-hiit';
        };
      } else if (inactiveOrg && !hasGHAccess) {
        // Non-paying member or admin whose group expired
        statusText.innerHTML = '<p>' + t('noSubOrg') + '</p>';
        actionBtn.textContent   = t('viewPlansBtn');
        actionBtn.style.display = 'inline-block';
        actionBtn.onclick = function() { window.location.href = '/pages/join-group-hiit'; };
      } else {
       // Individual with no subscription
        const hasEverSubscribed = customerInfo &&
          customerInfo.allExpirationDatesByProduct &&
          Object.keys(customerInfo.allExpirationDatesByProduct).length > 0;

        statusText.innerHTML = '<p>' + (hasEverSubscribed
          ? t('noSubIndividualWinBack')
          : t('noSubIndividual')) + '</p>';
        actionBtn.textContent   = t('viewPlansBtn');
        actionBtn.style.display = 'inline-block';
        actionBtn.onclick = function() { window.location.href = '/pages/join-group-hiit'; };
      }
    }
  }

  // ── MAIN PAGE INIT ─────────────────────────────────────────────────────────
  async function initMembershipPage(ghDetail) {

    var userType  = ghDetail.userType;
    var isLoggedIn = ghDetail.isLoggedIn;

    applyLanguage();

    var loggedOutMsg = document.getElementById('logged-out-message');
    if (loggedOutMsg) loggedOutMsg.style.display = 'none';

   if (!isLoggedIn) {
      setTimeout(function() {
        if (window.GH && !window.GH.hasAccess && window.Clerk && window.Clerk.user === null) {
          if (loggedOutMsg) loggedOutMsg.style.display = 'block';
        }
      }, 2000);
      return;
    }
    document.documentElement.classList.remove('clerk-synced-out');
    document.documentElement.classList.add('clerk-synced-in');
    localStorage.setItem('clerk_fast_sync', 'logged_in');

    document.getElementById('membership-management-root').style.display = 'block';
window.GH._accessFullyResolved = true;

    document.getElementById('membership-management-root').style.display = 'block';

    var profileBtn = document.getElementById('open-clerk-profile');
    if (profileBtn) profileBtn.onclick = function() { window.Clerk && window.Clerk.openUserProfile(); };

    var isGroup = ['group_owner', 'group_admin', 'group_member'].indexOf(userType) !== -1;
    if (isGroup) {
      document.getElementById('group-settings-section').style.display = 'block';
    }

    if (userType === 'group_member' || userType === 'group_admin') {
  var orgName = (window.GH && window.GH.orgName) ||
                (window.Clerk && window.Clerk.organization && window.Clerk.organization.name) ||
                ((_lang === 'es') ? 'tu grupo' : 'your group');
  document.getElementById('subscription-status-text').innerHTML =
    '<p>' + t('groupMemberSub', { orgName: orgName }) + '</p>';

  // Check if they also have an individual subscription
  // Don't return yet — fall through to RC to check for dual membership
  try {
    if (typeof Purchases !== 'undefined' && Purchases.Purchases) {
      var rcInstance2 = null;
      try { rcInstance2 = Purchases.Purchases.getSharedInstance(); } catch(e) {}
      if (!rcInstance2) {
        var userId2 = window.Clerk?.user?.id || null;
        if (userId2) {
          Purchases.Purchases.configure('rcb_sb_WSiRYMVWykLZbvHSZIuWTlllv', userId2);
          rcInstance2 = Purchases.Purchases.getSharedInstance();
        }
      }
      if (rcInstance2) {
        var customerInfo2 = await rcInstance2.getCustomerInfo();
        var activeEntitlements2 = customerInfo2 && customerInfo2.entitlements && customerInfo2.entitlements.active
          ? Object.values(customerInfo2.entitlements.active)
          : [];
        var individualEntitlement2 = activeEntitlements2.find(function(e) {
          var details = PLAN_DETAILS[e.productIdentifier];
          return details && details.seats === 1;
        });
        if (individualEntitlement2) {
          var indDetails2 = PLAN_DETAILS[individualEntitlement2.productIdentifier];
          var indExpiry2 = formatDate(individualEntitlement2.expirationDate);
          var indWillRenew2 = individualEntitlement2.willRenew;
          var userEmail2 = window.Clerk?.user?.primaryEmailAddress?.emailAddress || '';
          var indPortalUrl2 = getStripeUrl(false, userEmail2);
          var indSection2 = document.getElementById('individual-sub-section');
          if (!indSection2) {
            indSection2 = document.createElement('div');
            indSection2.id = 'individual-sub-section';
            indSection2.style.cssText = 'margin-top:24px;padding-top:24px;border-top:1px solid #e2e8f0;';
            document.getElementById('subscription-status-text').parentNode.appendChild(indSection2);
          }
          indSection2.innerHTML =
            '<p style="font-size:13px;font-weight:600;color:#232a2e;margin-bottom:8px;">Individual Subscription</p>' +
            '<p style="font-size:13px;color:#37474f;margin-bottom:8px;">' +
              (indDetails2 ? getPlanName(indDetails2.name) : 'Individual Membership') + ' — ' +
              (indWillRenew2 && indExpiry2 ? 'Renews ' + indExpiry2 : indExpiry2 ? 'Active until ' + indExpiry2 : 'Active') +
            '</p>' +
            '<p style="font-size:13px;color:#37474f;margin-bottom:12px;">You have an active individual subscription alongside your group membership. To avoid duplicate charges you may want to cancel it.</p>' +
            '<button onclick="window.location.href=\'' + indPortalUrl2 + '\'" style="background:#232a2e;color:#ffee58;border:none;border-radius:8px;padding:10px 20px;font-size:13px;font-weight:600;cursor:pointer;">Manage Individual Plan</button>';
        }
      }
    }
  } catch(rcErr) {
    console.warn('[MM] Could not check for individual sub:', rcErr);
  }
  return;
}

    try {
      if (typeof Purchases === 'undefined' || !Purchases.Purchases) {
        document.getElementById('subscription-status-text').innerHTML =
          '<p style="color:red;">RevenueCat SDK not found. Please check your script tags.</p>';
        return;
      }

      var rcInstance = null;
      try { rcInstance = Purchases.Purchases.getSharedInstance(); } catch(e) {}

      if (!rcInstance) {
        const userId = window.Clerk?.user?.id || null;
Purchases.Purchases.configure('rcb_sb_WSiRYMVWykLZbvHSZIuWTlllv', userId);
        rcInstance = Purchases.Purchases.getSharedInstance();
      }

      var customerInfo = await rcInstance.getCustomerInfo();

      var offerings = null;
      if (window.GH && window.GH.userType === 'group_owner') {
        try { offerings = await rcInstance.getOfferings(); } catch(e) { console.warn('[RC] Could not fetch offerings:', e); }
      }

      updateBillingUI(customerInfo, offerings);
    } catch(e) {
      console.error('RC billing load failed:', e);
      document.getElementById('subscription-status-text').innerHTML =
        '<p style="color:red;">Unable to load billing details. Please refresh the page.</p>';
    }
  }

  // Apply language immediately on load for static text
  applyLanguage();

  document.addEventListener('gh:accessResolved', function(e) {
    initMembershipPage(e.detail);
  });

  if (window.GH && window.GH.userType !== undefined) {
    setTimeout(function() {
      initMembershipPage({
        userType:   window.GH.userType,
        hasAccess:  window.GH.hasAccess,
        isLoggedIn: window.GH.isLoggedIn,
      });
    }, 50);
  }

  // Only show logged-out message if gh:accessResolved never fires
  setTimeout(function() {
    if (document.getElementById('membership-management-root').style.display === 'none' &&
        document.getElementById('logged-out-message').style.display === 'none') {
      if (window.Clerk && window.Clerk.user === null) {
        document.getElementById('logged-out-message').style.display = 'block';
      }
    }
  }, 4000);

})();